import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ServiceType } from "../_types/services-types";

@Injectable({
    providedIn: 'root',
})

export class ServicesTypesService extends Service<ServiceType> {
  public override type = 'serviceTypes';
  public override url = 'attendance/serviceTypes';
  
  //habilita la cache para el metodo all
  public override CACHEABLE_METHODS: any = { all: true };
}
